import { Switch } from '@thanx/uikit/switch'
import { buildTranslate } from 'locales'
import { useSelector } from 'react-redux'
import { selectIsSegmentSaving } from 'slices/aiSegmentBuilder'

const t = buildTranslate('components.ai.segment_visualization')

interface SegmentActionsProps {
  showCustomizeButton: boolean
  onSaveClick: () => void
  onViewSegmentClick: () => void
  savedSegmentId?: number
  isLatestDraftSegment?: boolean
  hasAnySavedSegment?: boolean
}

const SegmentActions = ({
  showCustomizeButton,
  onSaveClick,
  onViewSegmentClick,
  savedSegmentId,
  isLatestDraftSegment = false,
  hasAnySavedSegment = false,
}: SegmentActionsProps) => {
  const isSegmentSaving = useSelector(selectIsSegmentSaving)

  // Only show save button if:
  // 1. It's the latest draft segment (implies draft state)
  // 2. No segment has been saved yet
  const showSaveButton = isLatestDraftSegment && !hasAnySavedSegment

  // View segment follows the same "latest card only" rule as save: every
  // assistant turn renders its own card, and repeating the button on each of
  // them just points several controls at the same segment.
  const showViewSegmentButton = isLatestDraftSegment

  return (
    <div className="thanx-ai-segment-visualization__actions">
      <Switch condition={showCustomizeButton}>
        <button
          className="thanx-ai-segment-visualization__action-btn thanx-ai-segment-visualization__action-btn--secondary"
          disabled
          title="Coming soon"
        >
          Customize
        </button>
      </Switch>
      <Switch condition={showViewSegmentButton}>
        <button
          className="thanx-ai-segment-visualization__action-btn thanx-ai-segment-visualization__action-btn--secondary"
          onClick={onViewSegmentClick}
          disabled={!savedSegmentId}
        >
          {t('view_segment')}
        </button>
      </Switch>
      <Switch condition={showSaveButton}>
        <button
          className="thanx-ai-segment-visualization__action-btn thanx-ai-segment-visualization__action-btn--primary"
          onClick={onSaveClick}
          disabled={isSegmentSaving}
        >
          {isSegmentSaving ? t('saving_button') : t('submit_button')}
        </button>
      </Switch>
    </div>
  )
}

export default SegmentActions
